import { useEffect, useRef } from 'react'
import { FaAward, FaHandshake, FaGraduationCap, FaClock, FaComments } from 'react-icons/fa'
import './About.css'

const cards = [
  {
    title: 'Experience',
    icon: FaAward,
    text: 'As an agent who has been in the business for many years, I have a great understanding of the local market and have many contacts in the industry.',
  },
  {
    title: 'Professional',
    icon: FaHandshake,
    text: 'By upholding proffesionalism, I am someone who works honestly, ethically, and operate with integrity.',
  },
  {
    title: 'Knowledge',
    icon: FaGraduationCap,
    text: 'I maintain a deep understanding of the real estate industry, including regulations, and best practices, making me a valuable resource for my clients.',
  },
  {
    title: 'Availability',
    icon: FaClock,
    text: 'Working with my client is my top priority and being available to them as much as possible is a goal.',
  },
  {
    title: 'Communication',
    icon: FaComments,
    text: 'I am responsive, easy to reach, and clearly communicate with my client.',
  },
]

function About() {
  const cardRefs = useRef([])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('card-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.15 }
    )

    cardRefs.current.forEach((el) => el && observer.observe(el))
    return () => observer.disconnect()
  }, [])

  return (
    <div className='About'>
      <div className="about-inner">
        <div className="missionStatement">
          <h2 id='header'><strong>Real</strong> Estate. <strong>Real</strong> Results</h2>
          <p id='missionStatement'>
            My mission is to provide my clients with exceptional real estate,
            providing unmatched expertise, professionalism and personal attention.
            I am committed to building lasting relationships with each of my clients
            based on trust, honesty and respect, and strive to exceed their expectations
            every step of the way. Whether you are buying, selling or investing in real
            estate, I am here to guide you through the process and help you achieve your
            goals. My success is measured by customer satisfaction and I am committed to
            ensuring that every transaction is a positive and rewarding experience.
          </p>
          <div className="section-divider" />
        </div>

        <div className="values">
          <h2 className="valueProp"><strong>Why</strong> go with me?</h2>
          <ul className="valueList">
            {cards.map((card, i) => {
              const Icon = card.icon
              return (
                <li
                  key={card.title}
                  className="card"
                  ref={(el) => (cardRefs.current[i] = el)}
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="card-icon"><Icon /></div>
                  <h3 className="value">{card.title}</h3>
                  <p className="valueStatement">{card.text}</p>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default About;
